<template>
  <div id="app" class="container px-0" ontouchstart="">
    <router-view />
    <footer>
      <cookie-law theme="base" button-text="同意">
        <template #message>
          為了提升服務品質，我們會使用Cookie或其他類似技術，用以維護本網站的常態運作、內容規劃和廣告、提供社交媒體運用並分析流量。我們會和社群媒體、廣告和分析的合作夥伴，分享有關您使用本網站的資訊。
        </template>
      </cookie-law>
    </footer>
  </div>
</template>

<script>
import CookieLaw from 'vue-cookie-law'

export default {
  components: { CookieLaw },
}
</script>

<style lang="scss">
@import '~@/assets/bootstrap@5.0.0-alpha3/bootstrap.min.css';

.container {
  max-width: 576px;
  min-width: 576px;
}

button:active,
a:active {
  transform: scale(0.95);
  transition: 0.1s;
}

// background
.bg-pink {
  position: relative;
  z-index: 0;
  background-image: url('~@img/img_BG.jpg');
  background-repeat: no-repeat;
  background-color: rgb(245, 177, 161);
  background-size: 100%;

  &::before {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: white;
    background-size: 100%;
    opacity: 0.3;
  }
}

// input border
.gold-border {
  background: linear-gradient(90deg, #f6e58a, #74441f);
  padding: 0.2rem;
  border-radius: 23px;
}

.form-control {
  border: 0;
}

// cookie-law
.Cookie__content {
  font-size: 1.5rem;
}

.Cookie--base .Cookie__button {
  font-size: 1.5rem;
}

// sweetAlert2
#swal2-content {
  font-size: 1.5rem;
}
</style>